import { useCallback } from 'react';
import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { CellString } from '../../table/cells/CellString';

export const ModelCellReferenceBase = ({
  getValue,
  ...props
}: TableInheritedProps) => {
  const syntheticGetValue = useCallback(
    () => getValue!()?.display_name,
    [getValue]
  );

  return <CellString getValue={syntheticGetValue} {...props}></CellString>;
};

export const ModelCellReference = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute(
    'ModelCellReference',
    ModelCellReferenceBase,
    props
  );
